export default "__VITE_ASSET__BSUpunPf__"